<template>
    <bita-modal
            :id="modalId"
            :title="title"
            :modal-lg="true"
            :isLoading="isLoading"
            @close="onCloseModal">
        <div slot="body">
            <bita-grid
                ref="grid"
                :columns="gridColumns"
                :read-data="readData"
                :hasRow="false"
                :resizable="true"
                :schema-total="'total'"
                :schema-data="'data'"
                :has-row-number="false"
            />
        </div>
        <div slot="footer">
            <bita-bootbutton
                    class="mr-2"
                    type="danger"
                    title="بستن"
                    icon="fas fa-times"
                    btn-width="150px"
                    data-dismiss="modal"
            />
        </div>
    </bita-modal>
</template>
<script>
export default {
    props: {
        modalId: {},
        isLoading: {},
        title: {},
        propsData: {},
    },
    computed: {
        gridColumns() {
            return [
                { title: "#", template: this.$getTemplate, width: "40px" },
                {
                    field: "tracking_code",
                    title: "کد پیگیری",
                    template: (e) => (e.tracking_code ? e.tracking_code : " - "),
                },
                {
                    field: "tracking_code",
                    title: "کد پیگیری",
                    template: (e) => (e.tracking_code ? e.tracking_code : " - "),
                },
                {
                    field: "tracking_code",
                    title: "کد پیگیری",
                    template: (e) => (e.tracking_code ? e.tracking_code : " - "),
                },
                {
                    field: "tracking_code",
                    title: "کد پیگیری",
                    template: (e) => (e.tracking_code ? e.tracking_code : " - "),
                },
                {
                    field: "tracking_code",
                    title: "کد پیگیری",
                    template: (e) => (e.tracking_code ? e.tracking_code : " - "),
                },
                {
                    field: "tracking_code",
                    title: "کد پیگیری",
                    template: (e) => (e.tracking_code ? e.tracking_code : " - "),
                },
                {
                    field: "tracking_code",
                    title: "کد پیگیری",
                    template: (e) => (e.tracking_code ? e.tracking_code : " - "),
                },
                {
                    field: "tracking_code",
                    title: "کد پیگیری",
                    template: (e) => (e.tracking_code ? e.tracking_code : " - "),
                },
            ]
        }
    },
    watch: {
        propsData: function(_data){
        }
    },
    methods: {
        onCloseModal() {},
        readData() {
            
        },
    }
};
</script>